/* Ronner Logo Marquee — pauses the animation while off-screen (perf) and on touch/tap. */
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.rtInitialized === 'true') return;
    section.dataset.rtInitialized = 'true';

    var track = section.querySelector('.ronner-marquee__track');
    if (!track || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          track.classList.toggle('is-paused', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(section);

    // Touch devices don't have :hover — tap to toggle pause when "pause on hover" is enabled
    if (section.classList.contains('ronner-marquee--pausable')) {
      section.addEventListener('click', function (e) {
        if (e.target.closest('.ronner-marquee__link')) return; // let real links work
        track.classList.toggle('is-paused');
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('.ronner-marquee');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ronner-marquee');
    if (section) initSection(section);
  });
})();
